module.exports = __webpack_public_path__ + "img/btzl.418f195e.png";